<li
  class="form-autocomplete-item"
  [class.selected]="selected"
  role="option"
  tabindex="0"
  [attr.selected]="selected"
  [attr.aria-selected]="ariaSelected"
>
  {{ text }}
</li>
